import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import school from './modules/school'
import editstudent from './modules/editstudent'

import classroom from './modules/classroom'
import answerquestion from  './modules/answerquestion'
import showMessage from './modules/showMessage'
import editor from './modules/editor'
import topic from './modules/topic'
import createpapermodal  from './modules/createpapermodal'
import topiclibrary  from './modules/topiclibrary'
import chapter  from './modules/chapter'
import paperlibrary  from './modules/paperlibrary'
import paperlibraryview  from './modules/paperlibraryview'
import practiceAnalysis from './modules/practiceAnalysis'
import reportlibrary from  './modules/reportlibrary'
import gameUser from './modules/gameUser'
import section from './modules/section'
import teachCourse from './modules/teachCourse'
import practice from './modules/practice'
import practicePushLog from './modules/practicePushLog'
import practiceView from './modules/practiceView'
// 存储部分组件的状态
import status from './modules/status'
import table from './modules/table'
import createPersistedState from "vuex-persistedstate"
//ppt 编辑器
import pptstatus from './ppt/pptstatus'

//学生答题
import studentAnswerquestion from  './modules/student/answerquestion'
import studentTable from  './modules/student/table'
import studentPractice from  './modules/student/practice'
import imgmodal from  './modules/student/imgmodal'
import studentStatus from './modules/student/status'

import * as types from '@/vuex/types'
import head from './modules/header'

Vue.use(Vuex);

const state = {
  headerPic: 'this.src="'+require('@/assets/images/default/student_default.png')+'"',//默认头像
  headerPic2: 'this.src="'+require('@/assets/images/default/personal_info.jpg')+'"',
  // 图片 视频 flash 不能正常显示时 默认图片
  defaultImgPic:'this.src="'+require('@/assets/images/default/img_default.png')+'"',
  defaultVideoPic:'this.src="'+require('@/assets/images/default/video_default.png')+'"',
  defaultFlashPic:'this.src="'+require('@/assets/images/default/flash_default.png')+'"',
  screenWidth : 0,
  screenHeight : 0,
  tableScreenWidth:0,//侧边栏表格宽度
  teachIndex : 0,
  titleData:{
    text:"学测主页",
    path:"/home/homelist"
  }
}

const actions = {
  setScreenWidth({commit}, screenWidth){
    commit(types.SET_SCREEN_WIDTH, screenWidth);
  },
  setScreenHeight({commit}, screenHeight){
    commit(types.SET_SCREEN_HEIGHT, screenHeight);
  },
  setTitleData({commit}, titleData){
    commit('SET_TITLE_DAT', titleData);
  },
  setTeachIndex({commit}, index){
    commit(types.SET_TEACH_INDEX, index);
  },
  setTableScreenWidth({commit}, width){
    commit('SET_TABLE_SCREEN_WIDTH', width);
  }
}

const mutations = {
  [types.SET_SCREEN_WIDTH](state, screenWidth) {
    Vue.set(state, 'screenWidth', screenWidth);
  },
  [types.SET_SCREEN_HEIGHT](state, screenHeight) {
    Vue.set(state, 'screenHeight', screenHeight);
  },
  ['SET_TITLE_DAT'](state, titleData){
    Vue.set(state, 'titleData', titleData);
  },
  [types.SET_TEACH_INDEX](state, index){
    Vue.set(state, 'teachIndex', index)
  },
  ['SET_TABLE_SCREEN_WIDTH'](state, width){
    Vue.set(state, 'tableScreenWidth', width)
  }
}

export default new Vuex.Store({
  state,
  actions,
  mutations,
  modules: {
    user,
    school,
    head,
    editstudent,
    classroom,
    answerquestion,
    status,
    table,
    showMessage,
    editor,
    topic,
    createpapermodal,
    topiclibrary,
    chapter,
    paperlibrary,
    paperlibraryview,
    // ppt 编辑器
    pptstatus,
    practiceAnalysis,
    reportlibrary,
    gameUser,
    section,
    teachCourse,
    practice,
    practicePushLog,
    practiceView,


    // 学生答题
    studentAnswerquestion,
    studentTable,
    studentPractice,
    imgmodal,
    studentStatus
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    // 默认持久化所有state,指定需要持久化的state,配置如下
    reducer(val) {
      return {
        // 储存Teachinglog.vue 引用的vuex数据。
        user:val.user,
        status:val.status,
        givelesson: val.givelesson,
        log:val.log
      }
    }
  })]
});



// WEBPACK FOOTER //
// ./src/vuex/store.js